<template>
  <div>
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <BBTable :columns="optionsTable"
             @edit="editServiceProvider"
             @delete="deleteServiceProvider"
             :rows="serviceProviderTableRowsData"
    />
    <Pagination :data="fullInfo" :getQuery="getServiceProvider" :limit="defLimit" class="bb-pagination"/>
  </div>
</template>

<script>
import Table from '@/components/Main/Table/Table'
import serviceProviderTableColumns from '@/constants/TablesOptions/serviceProviderTable'
import Pagination from '@/components/Main/Pagination/Pagination'
import BBTable from '@/components/Main/BBTable/BBTable'
import {debounce, forEach, findIndex} from 'lodash'
import ServiceProviderApi from '@/api/ServiceProvider/api'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import {ACTIVE_SERVICE_PROVIDER, PROSPECT_SERVICE_PROVIDER} from '@/constants/serviseProvider'

export default {
  name: 'ServiceProviderTable',
  components: {Pagination, Table, LoaderFly, BBTable},
  props: ['searchValue', 'statusType'],
  data () {
    return {
      optionsTable: serviceProviderTableColumns,
      fullInfo: {totalPages: 1},
      defLimit: 25,
      loaderRun: false,
      searchWords: '',
      filterByStatus: {
        active: false,
        prospect: false
      },
      statusFilter: [],
      noDataText: false
    }
  },
  computed: {
    serviceProviderTableColumnsData: {
      get () {
        return this.$store.getters.serviceProviderColumnsData
      },
      set (data) {
        this.$store.dispatch('setServiceProviderColumnsData', data)
      }
    },
    vendorTagsFilter: {
      get: function () {
        return this.$store.getters.vendorTagsFilter
      },
      set: function (data) {
        this.$store.dispatch('setFilterVendorTag', data)
      }
    },
    vendorSearch: {
      get: function () {
        return this.$store.getters.vendorSearch
      },
      set: function (data) {
        this.$store.dispatch('setSearchVendor', data)
      }
    },
    serviceProviderTableRowsData: {
      get () {
        return this.$store.getters.serviceProviderRowsData
      },
      set (data) {
        this.$store.dispatch('setServiceProviderRowsData', data)
      }
    },
    searchVendorType () {
      return this.$store.getters.searchType
    },
    getWithSearch () {
      return debounce(this.getServiceProvider, 250)
    }
  },
  methods: {
    addActions () {
      forEach(this.serviceProviderTableColumnsData, item => {
        if (item.sort) {
          item.get = this.getServiceProvider
        }
        if (item.actions) {
          item.actions.delete = this.deleteServiceProvider
          item.actions.edit = this.editServiceProvider
          item.actions.uploadFile = this.uploadAllFiles
        }
      })
    },
    deleteServiceProvider ({row}) {
      const {id} = row
      const index = findIndex(this.serviceProviderTableRowsData, {id})
      ServiceProviderApi.deleteServiceProvider(id)
        .then(() => {
          this.serviceProviderTableRowsData.splice(index, 1)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    uploadAllFiles (files, row, rows, copyRow) {
      forEach(files, file => {
        this.uploadFile(this.setFileData(file), row, rows, copyRow)
      })
    },
    editServiceProvider ({row}) {
      this.$router.push({
        name: 'ContactServiceProvider',
        params: {id: row.id, contactType: 3, item: row, editMode: true},
        props: true
      })
    },
    getServiceProvider ({limit = this.defLimit, query, page}) {
      if (this.searchVendorType === 'Services/Goods') {
        this.getGoodsServiceProvider({limit, query, page})
        return
      }

      const isHashtagSearch = this.searchVendorType === 'hashtag'

      const search = !isHashtagSearch ? this.vendorSearch : undefined
      const sort = query || 'sort[]=_id&sort[]=-1'
      const tagsId = this.vendorTagsFilter.map(item => item.id)
      const tags = isHashtagSearch ? tagsId.join('&vendorTags[]=') : undefined
      this.loaderRun = true
      ServiceProviderApi.getServiceProvider({limit, sort, status: this.statusType, search, tags, page})
        .then((resp) => {
          this.addActions()
          const result = resp.data.serviceproviders.filter(item => item)
          this.serviceProviderTableRowsData = result.map(item => {
            if (item.status === ACTIVE_SERVICE_PROVIDER.id) {
              item.stringStatus = ACTIVE_SERVICE_PROVIDER.name
              return item
            } else {
              item.stringStatus = PROSPECT_SERVICE_PROVIDER.name
              return item
            }
          })
          this.fullInfo = resp.data
          this.loaderRun = false
          this.noDataText = !this.serviceProviderTableRowsData.length
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
          this.noDataText = true
        })
    },
    getGoodsServiceProvider ({limit = this.defLimit, query, page}) {
      const search = this.vendorSearch
      const sort = query || 'sort[]=_id&sort[]=-1'
      this.loaderRun = true
      ServiceProviderApi.getGoodsServiceProvider({limit, sort, status: this.statusType, search, page})
        .then((resp) => {
          this.addActions()
          const result = resp.data.serviceproviders.filter(item => item)
          this.serviceProviderTableRowsData = result.map(item => {
            if (item.status === ACTIVE_SERVICE_PROVIDER.id) {
              item.stringStatus = ACTIVE_SERVICE_PROVIDER.name
              return item
            } else {
              item.stringStatus = PROSPECT_SERVICE_PROVIDER.name
              return item
            }
          })
          this.fullInfo = resp.data
          this.loaderRun = false
          this.noDataText = !this.serviceProviderTableRowsData.length
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
          this.noDataText = true
        })
    }
  },
  watch: {
    searchVendorType () {
      this.getServiceProvider({})
    },
    searchValue (newVal, oldVal) {
      if (newVal && this.searchValue.length < 2) return
      if (newVal !== oldVal) {
        this.getWithSearch({})
      }
    },
    statusType () {
      this.getServiceProvider({})
    },
    vendorSearch () {
      this.getServiceProvider({})
    },
    vendorTagsFilter () {
      this.getServiceProvider({})
    }
  },
  beforeMount () {
    this.getServiceProvider({})
    this.serviceProviderTableColumnsData = serviceProviderTableColumns
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactsTable/ServiceProviderTable.vue